import React from "react";

interface PaginationProps {
  pageNumber: number;
  pageSize: number;
  totalCount: number;
  onPageChange: (page: number) => void;
}

const Pagination: React.FC<PaginationProps> = ({ pageNumber, pageSize, totalCount, onPageChange }) => {
  const totalPages = Math.ceil(totalCount / pageSize);
  if (totalPages <= 1) return null;

  const start = Math.max(1, pageNumber - 1);
  const end = Math.min(totalPages, pageNumber + 1);
  const pages = Array.from({ length: end - start + 1 }, (_, i) => start + i);

  return (
    <div className="d-flex justify-content-between align-items-center mt-3">
      <small className="text-muted">
        Showing {(pageNumber - 1) * pageSize + 1}–{Math.min(pageNumber * pageSize, totalCount)} of {totalCount}
      </small>
      <nav>
        <ul className="pagination pagination-sm mb-0">
          <li className={`page-item ${pageNumber === 1 ? "disabled" : ""}`}>
            <button className="page-link" onClick={() => onPageChange(pageNumber - 1)}>&laquo;</button>
          </li>
          {pages.map((p) => (
            <li key={p} className={`page-item ${pageNumber === p ? "active" : ""}`}>
              <button className="page-link" onClick={() => onPageChange(p)}>{p}</button>
            </li>
          ))}
          <li className={`page-item ${pageNumber >= totalPages ? "disabled" : ""}`}>
            <button className="page-link" onClick={() => onPageChange(pageNumber + 1)}>&raquo;</button>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default Pagination;
